module.exports = __webpack_public_path__ + "img/16.10557aa0.svg";